import styled from 'styled-components';

import { Item } from './CardData.styles';

export const StyledItem = styled(Item)`
  && {
    @media (max-width: 1280px) {
      flex-direction: column;
      align-items: flex-start;
      row-gap: ${({ theme }) => theme.spacing.s1};
    }
  }
`;
